import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Download, Eye, Loader2 } from 'lucide-react';
import { downloadDocument, openDocument } from '@/utils/documents';
import { PREVIEW_EXTENSIONS } from './documentUploadConfig';

export const DocumentFileLink = ({ url, label, testId, onAccess, compact = false }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const extension = url.split('?')[0].split('.').pop().toLowerCase();
  const mustDownload = !PREVIEW_EXTENSIONS.includes(extension);
  const activate = async () => {
    onAccess?.();
    if (!mustDownload) { openDocument(url, `${label}.${extension}`); return; }
    setBusy(true);
    setError(false);
    try {
      // Unsupported preview types retain their original bytes and file format.
      await downloadDocument(url, `${label}.${extension}`);
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  };
  const Icon = busy ? Loader2 : mustDownload ? Download : Eye;
  return <>
    <button type="button" onClick={activate} disabled={busy}
      className={`inline-flex items-center gap-2 min-h-11 text-sm transition-colors text-left disabled:opacity-60 ${compact ? 'px-2.5 py-1 rounded-md bg-gray-50 hover:bg-gray-100 border border-gray-200 text-gray-700' : 'text-blue-700 underline underline-offset-2 hover:text-blue-900'}`} data-testid={testId}>
      <Icon className={`h-4 w-4 shrink-0 ${busy ? 'animate-spin' : ''}`} aria-hidden="true" />
      <span className="break-words">{t(`candidateProfile.upload.${mustDownload ? 'downloadFile' : 'openFile'}`, { name: label, format: extension.toUpperCase() })}</span>
    </button>
    {error && <p role="alert" className="text-sm text-red-700" data-testid={`${testId}-error`}>{t('candidateProfile.upload.downloadError')}</p>}
  </>;
};